import '../assets/styles/css/NavBarTop.css'
import logoVV from '../assets/img/VVLOGO.png'

function NavBar() {
  return (
    <nav className={'navBarTop'}>
      <div className={'navBarCnt'}>
        <div>
          <a href='http://www.vicensvives.com'>
            <img alt='logo' src={logoVV} />
          </a>
        </div>
      </div>
    </nav>
  )
}
export default NavBar
